module.exports = __webpack_public_path__ + "static/media/higiene-market.f9915c33.jpg";